/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Template from "./features/template";

const ManageBotsTemplate = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Template />
        </section>
      </Layout>
    </>
  );
};
export default ManageBotsTemplate;
